<template>
  <div class="h-full card hover:shadow">
    <div class="h-full">
      <div class="">
        <div class="relative">
          <img :src="$firstImage(item.images, 'small')" alt="" class="
              img
              rounded-t
              object-center
              h-10rem
              object-cover
              cursor-pointer
            " @click="go(item.id)" :onerror="defaultUrl" />
          <div class="status absolute z-10 inset-0 " v-if="item.status != 10 || !item.stock">
            <span class=" iconfont icon-yixiajia" v-if="item.status == 0"></span>

            <span class="iconfont icon-yishouqing" v-else-if="!item.stock"></span>
          </div>
        </div>

        <div class="h-full mx-2 mt-3 mb-3">
          <p class="font-bold text-base">
            <span class="cursor-pointer hover:underline" @click="go(item.id)">{{ item.name }}</span>
          </p>
          <p class="text-xs ellipsis mt-1 text-gray-500" v-if="item.attribute_text">
            {{ item.attribute_text }}
          </p>
          <p class="text-xs ellipsis mt-1 text-gray-500" v-else>&nbsp;</p>
          <p class="space-x-2 text-xs">
            <span class="text-gray-400  whitespace-nowrap">{{ $t("已售") }}：{{ item.sales }}</span>
            <span class="text-gray-400  whitespace-nowrap">{{ $t('库存') }}：{{ item.stock }}</span>
          </p>
          <p class="mt-2 text-xs flex justify-around mb-2 flex-nowrap">
            <span class="text-red-600">{{ $p(item.price) }}</span>
          
          </p>
          <el-button type="primary" size="mini" @click="cl(item)">{{
            $t("采购")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import bus from "@/API/util/bus.js";
export default {
  props: { item: Object, flight: Number },

  setup(props, ctx) {
    const flight = ref(Number(props.flight));
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';
    const go = (id) => {
      ctx.root.$router.push({
        name: "ProductDetail",
        params: { id },
        query: { flight: flight.value },
      });
    };

    const cl = (e) => {
      console.log('cf');
      bus.emit("select", e);
    };
    return { go, cl, defaultUrl };
  },
};
</script>

<style scoped lang="scss">@import "@/style/stl.scss";
#airlift::before {
  content: "空运：$ ";
}
#tally::after {
  font-size: 0.75rem;
  line-height: 1rem;
  content: " / 扎起";
}
.status {
  background-color: rgba(0, 0, 0, 0.4);
  color: #ffffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.status .iconfont {
  font-size: 4rem;
}</style>
